module.exports = __webpack_public_path__ + "img/banner_sample_1.55239005.png";